import styled from 'styled-components/macro';

export const StyledDescription = styled.p`
  margin-bottom: 1rem;
  color: ${({ theme }) => theme.colors.text.secondary};
`;
